import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import {useState} from 'react';
import Glass from './pages/glass';
import { MathJaxContext } from 'better-react-mathjax';

function App() {
  const [darkMode, setDarkMode] = useState(true);

  // Apply dark mode to the body element
  if (darkMode) {
    document.body.classList.add('dark-mode');
  } else {
    document.body.classList.remove('dark-mode');
  }

  return (
    <Router>
      <MathJaxContext>               
      <div className={darkMode ? 'dark-mode' : ''}>
        <Routes>
          <Route path="/" element={<Glass darkMode={darkMode} triggerDarkMode={setDarkMode} />} />
        </Routes>
      </div>
      </MathJaxContext>
    </Router>
  );
}

export default App;
